import { Component, Input, OnInit, ViewChild } from "@angular/core";
import { DashboardMultiStationService } from "../dashboard-multistation.service";
import { MsBlockedAttemptTableComponent } from "./ms-blocked-attempt-table/ms-blocked-attempt-table.component";

@Component({
	selector: "caass-ms-blocked-list-attempts",
	templateUrl: "./ms-blocked-list-attempts.component.html",
	styleUrls: ["./ms-blocked-list-attempts.component.css"],
})
export class MsBlockedListAttemptsComponent implements OnInit {
	constructor(private visitorService: DashboardMultiStationService) {}

	ngOnInit(): void {
		this.loadData();
	}

	ngOnChanges() {
		this.loadData();
	}

	//////////////////////////////////////////////////////////
	// Data
	//////////////////////////////////////////////////////////

	@Input() FacilityID: number = -1;

	AttemptsToday: number = 0;
	AttemptsMTD: number = 0;
	AttemptsYTD: number = 0;
	AttemptsAll: number = 0;

	StatsLoading: boolean = false;
	TableLoading: boolean = false;

	OptionID: number = 0;
	Title: string = "Facility";

	lstVisitorPassDetail: any;

	@ViewChild(MsBlockedAttemptTableComponent)
	tableRef: MsBlockedAttemptTableComponent;

	//////////////////////////////////////////////////////////

	//////////////////////////////////////////////////////////
	// Load Data
	//////////////////////////////////////////////////////////

	loadData() {
		this.ClearData();

		if (this.FacilityID == undefined || this.FacilityID < 0) {
			return;
		}

		this.loadStats();
		this.loadTable();
	}

	loadStats() {
		this.StatsLoading = true;

		var result = this.visitorService.BlockedListAttemptStatsSelect(this.OptionID == 0 ? this.FacilityID : -1);
		result.subscribe(
			(response: any) => {
				this.AttemptsToday = response.AttemptsToday == undefined ? 0 : response.AttemptsToday;
				this.AttemptsMTD = response.AttemptsMTD == undefined ? 0 : response.AttemptsMTD;
				this.AttemptsYTD = response.AttemptsYTD == undefined ? 0 : response.AttemptsYTD;
				this.AttemptsAll = response.AttemptsAll == undefined ? 0 : response.AttemptsAll;

				this.StatsLoading = false;
			},
			(error) => {
				this.StatsLoading = false;
			}
		);
	}

	loadTable() {
		this.TableLoading = true;

		var result = this.visitorService.BlockedAttemptDetailsInfoSelectList(this.OptionID == 0 ? this.FacilityID : -1);
		result.subscribe(
			(response: any) => {
				this.lstVisitorPassDetail = response;

				for (var z = 0; z < this.lstVisitorPassDetail.length; z++) {
					var next = this.lstVisitorPassDetail[z];

					next.RouterLink = "/multistation/viewlog/" + next.VisitorPassDetailID;
				}

				this.TableLoading = false;
			},
			(error) => {
				this.TableLoading = false;
			}
		);
	}

	//////////////////////////////////////////////////////////

	//////////////////////////////////////////////////////////
	// Buttons
	//////////////////////////////////////////////////////////

	SelectOption(opt) {
		this.OptionID = opt;

		if (this.OptionID == 0) {
			this.Title = "Facility";
		} else if (this.OptionID == 1) {
			this.Title = "District";
		}

		this.loadData();
	}
	//////////////////////////////////////////////////////////

	//////////////////////////////////////////////////////////
	// Helpers
	//////////////////////////////////////////////////////////

	ClearData() {
		this.AttemptsToday = 0;
		this.AttemptsMTD = 0;
		this.AttemptsYTD = 0;
		this.AttemptsAll = 0;
	}

	//////////////////////////////////////////////////////////
}
